import { FecImportMappingTab } from '../enums/fecImportMappingTab'
import { FecMappingReviewStatus } from '../enums/fecMappingReviewStatus'
import type { FecImportItem } from '../query-api'

const areAllConfirmed = (statuses: Array<FecMappingReviewStatus | null>): boolean =>
  statuses.length > 0 && statuses.every((status) => status === FecMappingReviewStatus.Confirmed)

/**
 * Resume on the first tab that still needs the user: a tab is skipped once every file has the domains up to and
 * including it confirmed.
 */
export const getFecImportInitialMappingTab = (
  fecImports: Array<Pick<FecImportItem, 'accountMappingStatus' | 'journalMappingStatus'>>,
): FecImportMappingTab => {
  if (!areAllConfirmed(fecImports.map(({ journalMappingStatus }) => journalMappingStatus))) {
    return FecImportMappingTab.Journals
  }

  return areAllConfirmed(fecImports.map(({ accountMappingStatus }) => accountMappingStatus))
    ? FecImportMappingTab.ThirdPartyAccounts
    : FecImportMappingTab.ChartOfAccounts
}
